import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {selectStore} from "../../../../../../store/selector";
import {Skeleton} from "antd";
import {AdmissionTableContent} from "../../../EntrantApplication/AdmissionTableContent";
import {Input} from "antd";
import {fetchGetTotalResultAction} from "../../../../../../store/pages/admission/actions";
import {decodeBase64} from "../../../../../../utils/decodeBase64";

const {TextArea} = Input;

export const ExecutorStepFive = ({
                                   declineReason,
                                   declineReasonTextHandler,
                                 }:any) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps']);

  const education_order_id = decodeBase64(searchParams.get("education_order_id"));

  const {admission:{getTotalResult}} = useSelector(selectStore)

  const setStatus = (text:any) => {
    switch (text) {
      case '8':
        return t('admissionView:statuses.32')
      case '20':
        return t('admissionView:statuses.20')
      case '22':
        return t('admissionView:statuses.22')
      case '26':
        return t('admissionView:statuses.26')
      case '24':
      case '30':
        return t('admissionView:statuses.30')
      case '31':
        return t('admissionView:statuses.31')
      default:
        return t('stepsTitle.stepFive.wait')
    }
  }

  useEffect(() => {
    // user_id
    //@ts-ignore
    dispatch(fetchGetTotalResultAction({education_order_id}))
  }, [])

  const columns = [
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.specialty')}`,
      dataIndex: 'specialty',
      key: 'specialty',
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.qualification')}`,
      dataIndex: 'qualification',
      key: 'qualification',
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.college')}`,
      dataIndex: 'college',
      key: 'college',
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.language')}`,
      dataIndex: 'language',
      key: 'language',
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.priority')}`,
      dataIndex: 'priority',
      key: 'priority',
      render: (text:any) => {
        return (
          <span className="admission__border-item admission__border-item--gray">
            {text}
          </span>
        )
      }
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (text:any) => {
        return (
          <span className="admission__border-item admission__border-item--gray">
            {setStatus(text)}
          </span>
        )
      }
    },
  ]

  const createDataSource = () => {
    let dataSource = [] as any

    if(getTotalResult.data && Array.isArray(getTotalResult.data.educationOrder.selectedSpecialities)){
      dataSource = [...getTotalResult.data.educationOrder.selectedSpecialities]

      dataSource.sort((a:any, b:any) => a.priority > b.priority ? 1 : -1)
    }

    return dataSource.map((item:any) => {
      return {
        key: item.id,
        specialty: item.speciality.code + " - " + item.speciality.caption,
        qualification: item.qualification.caption,
        college: item.college.name,
        language: item.language_of_education === 1 ? "Казахский" : item.language_of_education === 2 ? "Русский" : "Английский",
        priority: item.priority,
        status: item.status
      }
    })

  }

  return(
    <Skeleton loading={!getTotalResult.data}>
      <>
        {declineReason ?
          <div className="admission__content-item">
            <h3 className="admission__subtitle">{t('admissionView:stepsTitle.stepFive.caption.reason')}</h3>

            <span>{t('admissionView:stepsTitle.stepFive.comment')}</span>
            <TextArea
              placeholder={t('admissionView:stepsTitle.stepFive.text')}
              showCount
              maxLength={100}
              style={{ height: 120, borderRadius: 16 }}
              onChange={(e) => declineReasonTextHandler(e.target.value)}
            />
          </div>
          :
          <div className="admission__content-item">

            <AdmissionTableContent
              title={t('admissionView:stepsTitle.stepFive.caption.result')}
              data={createDataSource()}
              columns={columns}
            />
          </div>
        }
      </>
    </Skeleton>
  )
}